function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["children", "className", "isChecked", "isDisabled", "labelPosition", "name", "onChange", "size", "styleClasses", "variantName"];
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import React from 'react';
import "../../../../../enums/accordion.js";
import "../../../../../enums/alert.js";
import "../../../../../enums/avatar.js";
import "../../../../../enums/breakpoints.js";
import "../../../../../enums/button.js";
import "../../../../../enums/code-editor.js";
import "../../../../../enums/colors.js";
import "../../../../../enums/combobox.js";
import "../../../../../enums/date.js";
import "../../../../../enums/drag-and-drop.js";
import "../../../../../enums/dialog.js";
import "../../../../../enums/divider.js";
import "../../../../../enums/dropdown.js";
import "../../../../../enums/fieldset.js";
import "../../../../../enums/font-icon.js";
import "../../../../../enums/fonts.js";
import "../../../../../enums/headings.js";
import { InputLabelPositions } from "../../../../../enums/input.js";
import "../../../../../enums/keys.js";
import "../../../../../enums/list.js";
import "../../../../../enums/listbox.js";
import "../../../../../enums/loader.js";
import "../../../../../enums/margin.js";
import "../../../../../enums/option.js";
import "../../../../../enums/pill.js";
import "../../../../../enums/placements.js";
import "../../../../../enums/popout.js";
import "../../../../../enums/privacy.js";
import "../../../../../enums/radio-group.js";
import "../../../../../enums/status.js";
import { SwitchSize } from "../../../../../enums/switch.js";
import "../../../../../enums/table.js";
import "../../../../../enums/tooltip.js";
import "../../../../../enums/transitions.js";
import "../../../../../enums/widths.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var baseName = 'switch';
var keydownKeys = new Set(['Enter', 'Spacebar', ' ']);
/**
 * @deprecated Use `CheckboxSwitch` or `ImmediateSwitch` instead.
 */
var BaseSwitch = function BaseSwitch(_ref) {
  var _classnames;
  var children = _ref.children,
    className = _ref.className,
    isChecked = _ref.isChecked,
    isDisabled = _ref.isDisabled,
    _ref$labelPosition = _ref.labelPosition,
    labelPosition = _ref$labelPosition === void 0 ? InputLabelPositions.Left : _ref$labelPosition,
    name = _ref.name,
    onChange = _ref.onChange,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? SwitchSize.Medium : _ref$size,
    styleClasses = _ref.styleClasses,
    variantName = _ref.variantName,
    switchProps = _objectWithoutProperties(_ref, _excluded);
  var handleChange = function handleChange(e) {
    if (isDisabled) return;
    if (onChange && keydownKeys.has(e.key)) onChange(e);
    if (onChange && e.type === 'click') onChange(e);
  };
  return /*#__PURE__*/React.createElement("div", _extends({}, switchProps, {
    "aria-checked": isChecked,
    "aria-disabled": isDisabled,
    "aria-label": typeof children === 'string' ? children : name || '',
    className: classnames("bf-".concat(baseName, "__").concat(variantName), styleClasses[variantName], className, styleClasses[labelPosition], styleClasses[size], (_classnames = {}, _defineProperty(_classnames, styleClasses['no-label'], !children), _defineProperty(_classnames, styleClasses.checked, isChecked), _defineProperty(_classnames, styleClasses.disabled, isDisabled), _classnames)),
    onClick: handleChange,
    onKeyDown: handleChange,
    role: "switch",
    tabIndex: 0
  }), /*#__PURE__*/React.createElement("div", {
    className: styleClasses['switch-container']
  }, /*#__PURE__*/React.createElement("span", {
    className: styleClasses['switch-container--dot']
  })), /*#__PURE__*/React.createElement("div", {
    className: styleClasses['switch-label']
  }, children));
};
export { BaseSwitch };